export default "__VITE_ASSET__e10959d4__"